import { Injectable } from '@angular/core';
import { isProduction } from '@utils/utils';

@Injectable({
  providedIn: 'root'
})
export class OneTrustConfigService {

  private id: string;
  private scriptsLoaded = 0;
  private resolve: () => void;

  private document = document;

  private readonly PRO_ID = 'e23f7ec9-8def-4243-80bb-506ba8c7a7a3';
  private readonly PRE_ID = 'e23f7ec9-8def-4243-80bb-506ba8c7a7a3-test';

  constructor() { }

  init() {
    return new Promise<void>(resolve => {
      this.resolve = resolve;
      this.id = isProduction() ? this.PRO_ID : this.PRE_ID;
      this.addScriptTagConsent();
      this.addScriptTagScriptTemplates();
    });
  }
​
  private addScriptTagConsent() {
    if (this.document.getElementById('script_onetrust_consent')) { return; }
    const script: any = this.document.createElement('script');
    script.id = 'script_onetrust_consent';
    script.src = `https://cdn.cookielaw.org/consent/${this.id}/OtAutoBlock.js`;
    script.defer = true;
    this.bindAndAppendScript(script);
  }
​
  private addScriptTagScriptTemplates() {
    if (this.document.getElementById('script_onetrust_scripttemplates')) { return; }
    const script: any = this.document.createElement('script');
    script.id = 'script_onetrust_scripttemplates';
    script.src = `https://cdn.cookielaw.org/scripttemplates/otSDKStub.js`;
    script.defer = true;
    script.charset = 'UTF-8';
    script.setAttribute('data-document-language', 'true');
    script.setAttribute('data-domain-script', this.id);
    this.bindAndAppendScript(script);
  }
​
  private bindAndAppendScript(script: any) {
    const body = this.document.getElementsByTagName('head')[0];
    script.type = 'text/javascript';
    if (script.readyState) { // IE
      script.onreadystatechange = () => {
        script.onreadystatechange = null;
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          this.onScriptLoaded();
        }
      };
    } else { // Others
      script.onload = (e) => { this.onScriptLoaded(); };
      script.onerror = () => {};
    }
    body.appendChild(script);
  }
​
  private onScriptLoaded() {
    this.scriptsLoaded++;
    if (this.scriptsLoaded === 2) {
      this.resolve();
    }
  }

}
